import { LOGO_FULL, NAV_LINKS, CONTACT_EMAIL } from "../lib/site";

export const Footer = ({ onNavigate }) => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-gold/20 bg-eggshell py-16"
    >
      <div className="mx-auto max-w-[1500px] px-8 md:px-16">
        <div className="flex flex-col items-center gap-10 md:flex-row md:items-start md:justify-between">
          <img
            src={LOGO_FULL}
            alt="Metropolis Solutions LLC"
            className="w-44 md:w-56"
          />

          <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                onClick={() => onNavigate(l.href)}
                className="font-body text-xs uppercase tracking-[0.28em] text-ink/60 transition-colors duration-300 hover:text-gold"
              >
                {l.label}
              </button>
            ))}
          </div>

          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-body text-sm text-ink/60 transition-colors duration-300 hover:text-gold"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="deco-divider my-10" />

        <div className="flex flex-col items-center justify-between gap-4 text-center md:flex-row md:text-left">
          <p className="font-body text-xs tracking-wide text-ink/40">
            © {new Date().getFullYear()} Metropolis Solutions LLC · Government Contracting
          </p>
          <p className="font-body text-xs uppercase tracking-[0.3em] text-ink/40">
            Finding · Securing · Connecting
          </p>
        </div>
      </div>
    </footer>
  );
};
